<template>
  <div class="w-full">
    <div class="w-full max-display-card">
      <div class="text-center font-bold text-4xl px-10 leading-none">
        <span>How many rice have you ordered?</span>
      </div>
      <transition name="slide-fade1" appear>
        <screen-component-keyboard @setAmount="$emit('riceAmount', $event)" />
      </transition>
    </div>
    <transition name="slide-fade1" appear>
      <div class="w-full max-display flex justify-center">
        <jez-svg/>
<!--        <img-->
<!--          src="../../assets/img/person-3.png"-->
<!--          style="width:200px; height: 290px "-->
<!--          alt="person"-->
<!--        />-->
      </div>
    </transition>
    <x-footer />
  </div>
</template>
<script>
import XFooter from "@/components/Footer/XFooter";
import ScreenComponentKeyboard from "@/components/ScreenComponents/ScreenComponentKeyboard/ScreenComponentKeyboard";
import JezSvg from "@/components/ImageSvg/JezSvg";

export default {
  name: "RiceAmountComponent",
  components: { XFooter, ScreenComponentKeyboard,JezSvg }
};
</script>

